<template>

<app-panel-content :slim="true" :grow="true">

    <app-panel-title :text="item.name" :is-big="true" />
	
	<app-panel-summary label="Status" :tag="$constants.volunteers.slot.statusName[item.status]" :status="$constants.volunteers.slot.statusTheme[item.status]" :theme="$constants.volunteers.slot.statusTheme[item.status]" />
		
    <app-panel-summary label="Reference" :value="item.reference" />
	
    <app-panel-summary label="Role" :value="item.role.name" :reference="item.role.reference" />
	
    <app-panel-summary label="Day" :value="references.days[item.day]" v-if="item.role.type === $constants.volunteers.role.type.schedule" />
	
    <app-panel-summary label="Starts" :value="item.date.start | formatDate('h:mma')" v-if="item.role.type === $constants.volunteers.role.type.schedule" />
	
    <app-panel-summary label="Ends" :value="item.date.end | formatDate('h:mma')" v-if="item.role.type === $constants.volunteers.role.type.schedule" />
	
    <app-panel-summary label="Volunteers" :value="item.count.filled" />
		
    <app-panel-summary label="Capacity" :value="item.capacity" />
			
</app-panel-content>

</template>

<script>

export default {

    props: ['item', 'references']

}

</script>

<style scoped>

</style>
